export const AUTH_CONFIG = {
  clientId: process.env.AUTH0_CLIENT_ID,
  domain: process.env.AUTH0_DOMAIN,
  callbackUrl: process.env.AUTH0_CALLBACK_URL,
  apiUrl: process.env.AUTH0_API_URL
}



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js